// @view/workspace/FeedbackSuccessModalVisible.view.tsx

import React from "react";
import * as styles from "@styles/Feedback.css";
import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import type { FeedbackSubmissionViewProps } from "@ps-bridge/contracts/feedbackSubmission";

type FeedbackSuccessModalVisibleViewProps = Pick<
  FeedbackSubmissionViewProps,
  "onBackToHome" | "onCloseSuccessModal"
>;

const FeedbackSuccessModalVisibleView: React.FC<FeedbackSuccessModalVisibleViewProps> = ({
  onBackToHome,
  onCloseSuccessModal,
}) => {
  return (
    <div className={styles.modalContainer} role="dialog" aria-modal="true">
      <div className={styles.modalContent}>
        <p className={styles.successMessage}>Thank you for your feedback!</p>
        <div className={styles.gridContainer}>
          <div className={styles.gridRow}>
            <button
              className={styles.button}
              onClick={() => IO.run(onBackToHome(ok))}
            >
              <span className={styles.buttonText}>Back to Home</span>
            </button>

            <button
              className={styles.button}
              onClick={() => IO.run(onCloseSuccessModal(ok))}
            >
              <span className={styles.buttonText}>Close</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackSuccessModalVisibleView;
